// extracted by mini-css-extract-plugin
export default {"TableauBootstrap":"TableauComposante_TableauBootstrap__+zZOO","btn_stylo":"TableauComposante_btn_stylo__6SsHw"};